// extracted by mini-css-extract-plugin
export default {"wrap":"Qt-z","fullWidth":"Rt-z","items":"St-z","featureCss":"Tt-z","disabled":"Ut-z","imgCss":"Vt-z"};